var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import ENV from 'config/env';
import { EmailGptResponse } from 'packages/email/gpt-draft/entities/EmailGptResponse';
import { EntityBuilder } from '@decahedron/entity';
var EmailGptDraftRepository = /** @class */ (function (_super) {
    __extends(EmailGptDraftRepository, _super);
    function EmailGptDraftRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = 'email-gpt-draft-generators';
        _this.entity = null;
        _this.baseUrl = ENV.JOBILLA_API_ROOT;
        return _this;
    }
    EmailGptDraftRepository.prototype.generateEmail = function (draftParams) {
        return this.post(this.url, draftParams)
            .then(function (response) { return EntityBuilder.buildOne(EmailGptResponse, response); });
    };
    return EmailGptDraftRepository;
}(AbstractRepository));
export { EmailGptDraftRepository };
